import React from 'react';
import './VerificationBadge.css';

interface VerificationBadgeProps {
  badgeType?: string;
  companyName?: string;
  verificationDate?: string;
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

const VerificationBadge: React.FC<VerificationBadgeProps> = ({
  badgeType = 'verified_employee',
  companyName,
  verificationDate,
  size = 'medium',
  showTooltip = true
}) => {
  const getBadgeText = () => {
    switch (badgeType) {
      case 'verified_employee':
        return 'Verified Employee';
      case 'verified_alumni':
        return 'Verified Alumni';
      case 'verified_contractor':
        return 'Verified Contractor';
      default:
        return 'Verified';
    }
  };

  const getBadgeIcon = () => {
    switch (badgeType) {
      case 'verified_employee':
        return '✓';
      case 'verified_alumni':
        return '🎓';
      case 'verified_contractor':
        return '📋';
      default:
        return '✓';
    }
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className={`verification-badge ${size}`}>
      <span className="badge-icon">{getBadgeIcon()}</span>
      <span className="badge-text">{getBadgeText()}</span>
      
      {showTooltip && (
        <div className="badge-tooltip">
          <div className="tooltip-content">
            <strong>{getBadgeText()}</strong>
            {companyName && <p>Company: {companyName}</p>}
            {verificationDate && <p>Verified: {formatDate(verificationDate)}</p>}
            <p className="tooltip-info">
              This user has verified their employment and has access to the referral marketplace.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerificationBadge;